<div class="row" [class]="class">
  <div class="col" [routerLink]="backUrl" [fragment]="fragment ? fragment : null">
    <nb-icon icon="arrow-back-outline" class="back-icon"></nb-icon>
    <a class="link-text ml-2">{{ text }}</a>
  </div>
</div>